<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">{{ spinnerContent }}</div>
  </nz-spin>
</div>

<div class="dashboard-preview-wrapper">
  <h5 nz-typography class="nfl-form-label">Dashboard Layout Preview</h5>
  <div #gridContainer class="grid-stack">
    <div
      class="grid-stack-item"
      *ngFor="let widget of widgets"
      [attr.gs-id]="widget.chartId"
      [attr.gs-x]="widget.x"
      [attr.gs-y]="widget.y"
      [attr.gs-w]="widget.w"
      [attr.gs-h]="widget.h"
    >
      <div class="grid-stack-item-content" #widgetContent>
        <div class="remove-btn">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="removeWidget(widget.chartId)"
            title="Remove Widget"
            class="remove-widget-btn"
          >
            <span nz-icon nzType="close-square" nzTheme="outline"></span>
          </button>
        </div>
        <app-chart-preview
          [type]="widget.chartType"
          [displayConfig]="widget.chartConfig"
          [chartPreviewData]="widget.chartData"
          [hideHeader]="true"
          [parentSize]="{ height: widgetContent.offsetHeight, width: widgetContent.offsetWidth }"
          [isDashboardPreview]="true"
        ></app-chart-preview>
      </div>
    </div>
  </div>
</div>

<div class="footer-btn">
  <button
    nz-button
    nzType="primary"
    nzSize="large"
    [disabled]="!widgets.length || dashboardDetails?.invalid"
    (click)="
      isEditMode && activeDashboardData?.dashboardId
        ? updateDashboard(activeDashboardData!.dashboardId)
        : saveDashboard()
    "
  >
    {{ isEditMode ? 'Update' : 'Save' }}
  </button>
</div>
